export default __webpack_public_path__ + "static/B0026-e5aa27e5fb7d466f5ab7a68d4ec32074.png";